export enum PermissionLevel {
    Invalid = -1,
    Participant = 1,
    Clinician = 2,
    Researcher = 3,
    Admin = 4
};
